import { Settings } from 'utils/constants/dynamicSettings';
import { getSettingsValue } from 'utils/settings';

import { useSelector } from 'store/utils';

type UseSettings = () => (key: Settings) => string | number | boolean | null | string[] | Record<string, unknown>;

const useSettings: UseSettings = () => {
    const settings = useSelector((state) => state.dynamicSettings);

    return (key) => getSettingsValue(key, settings);
};

export default useSettings;
